import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import {reduxForm} from "redux-form";
import {AddChatPerson, EditChatPerson, GetChatPersonOne, DelChatPerson} from '../../actions/index';

import { connect } from 'react-redux';

class PersonsEdit extends Component {
    static contextTypes = {
        router: PropTypes.object,
        fields: PropTypes.object
    };
    constructor(props){
        super(props);
        this.state = {
            img: ''
        }
        this.handleChange = this.handleChange.bind(this);
        this.delChatPersonOpenModal = this.delChatPersonOpenModal.bind(this);
        this.delChatPerson = this.delChatPerson.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        if(this.props.params.id){
            this.props.GetChatPersonOne(this.props.params.id, token)
        }
    }
    delChatPerson(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelChatPerson(this.props.chat.chat_person_one.id, token).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.context.router.push('/chat/persons');
            }
        });
    }

    delChatPersonOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        let that = this;
        $('#DelChatPerson').modal('show');
    }
    closeModal(){
        $('#DelChatPerson').modal('hide');
        this.props.chat.chat_person_one = {};
    }

    SubmitForm(props){
        let token = localStorage.getItem('id_token_admin');
        if(this.props.params.id){
            this.props.EditChatPerson(this.props.params.id, props, token).then((response)=>{
                if(response.payload.status == 200){
                    this.context.router.push('/chat/persons');
                }
            });
        } else {
            this.props.AddChatPerson(token, props).then((response)=>{
                if(response.payload.status == 201){
                    this.context.router.push('/chat/persons');
                }
            });
        }
    }

    handleChange(event) {
        let obj = event.target.files[0];
        this.props.fields.avatar.onChange(obj);

        this.setState({
            img: obj.name
        })
    }
    
    componentWillUnmount(){
        this.props.chat.chat_person_one = {};
    }

    render() {
        const { fields: {
            name,
            avatar}, handleSubmit} = this.props;
        return (
            <div className="dashboard-wrapper">
                {this.props.params.id ? <p className="dashboard-title">{this.props.chat.chat_person_one.name} </p> : <p className="dashboard-title">Add Person</p>}
                <p className="dashboard-text">Chat</p>
                <form onSubmit={handleSubmit(this.SubmitForm.bind(this))}>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="name">Name</label>
                                </div>
                                <div className="col-md-4">
                                    <input type="text"
                                           placeholder="Name"
                                           className="form-control"
                                           name="name"
                                           id="name"
                                        {...name}
                                    />
                                </div>
                            </div>
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="flag">Avatar</label>
                                </div>
                                <div className="col-md-2">
                                    <label htmlFor="avatar" className="btn btn-primary pull-left">Choose file</label>
                                </div>
                                <div className="col-md-2">
                                    <input type="file"
                                           style={{display: 'none'}}
                                           name="avatar"
                                           className="form-control"
                                           id="avatar"
                                           onChange={this.handleChange}
                                    />
                                    <input type="text"
                                           placeholder="Choose file"
                                           className="form-control"
                                           name="avatar2"
                                           id="avatar2"
                                           disabled
                                           value = {this.state.img || avatar.value}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="white-block clearfix">
                            <div className="col-md-12 text-center button-group">
                                <Link to={"chat/persons"} className="btn btn-default">Back</Link>
                                {this.props.params.id ? <button  onClick={this.delChatPersonOpenModal} type="button" className="btn btn-danger">Delete</button> : ""}
                                <button type="submit" className="btn btn-primary">Save</button>

                            </div>
                        </div>
                    </div>
                </form>

                <div className="modal fade" id="DelChatPerson" tabIndex="-1" role="dialog" aria-labelledby="DelChatPersonLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelChatPerson"></span>
                                <p>Do you really want to delete person {this.props.chat.chat_person_one ? <span>{this.props.chat.chat_person_one.name} </span> : ""}?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delChatPerson} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>

        );
    }
}


function validate(values) {
    const errors = {};
    if(!values.name){
        errors.name = 'Enter a name'
    }
    if(!values.avatar){
        errors.avatar = 'Choose image'
    }

    return errors;
}

function  mapStateToProps(state) {
    return{
        chat: state.chat,
        initialValues: {
            name: state.chat.chat_person_one.name || '',
            avatar: state.chat.chat_person_one.avatar || ''
        }
    }
}

export default reduxForm({
    form: 'Edit Person',
    fields: ['name', 'avatar'],
    validate
}, mapStateToProps, {AddChatPerson, EditChatPerson, GetChatPersonOne, DelChatPerson})(PersonsEdit);



// WEBPACK FOOTER //
// ./src/components/chat/personsEdit.js